import { Moment } from "moment";
import { LookupFields, UserFields } from "src/modules/modules.type";
import { LookUpRecord, UserRecord } from "src/types/main";
import { FIELDS_TYPES } from "./type.config";

export const myTaskActionsListName = "MyTaskActions";
export const myTaskActionsStatusesListName = "MyTaskActionsStatuses";
export const myTaskActionCommentsListName = "MyTaskActionComments";
export const myTaskActionCommentsFilesListName = "MyTaskActionCommentsFiles";
export const myTaskActionsHistoryListName = "MyTaskActionsHistory";
export const myTasksTagsListName = "MyTasksTags";

export const myTaskActionsListNameFields = {
  [myTaskActionsListName]: {
    ID: FIELDS_TYPES.ID,
    MOldId: FIELDS_TYPES.STRING,
    Title: FIELDS_TYPES.STRING,
    View: FIELDS_TYPES.BOOLEAN,
    RejectDate: FIELDS_TYPES.DATE,
    Description: FIELDS_TYPES.STRING,
    Meeting: FIELDS_TYPES.LOOKUP,
    DateForDone: FIELDS_TYPES.DATE,
    Created: FIELDS_TYPES.DATE,
    CreateActionDate: FIELDS_TYPES.DATE,
    Status: FIELDS_TYPES.LOOKUP,
    Status_x003a_Color: FIELDS_TYPES.LOOKUP,
    Responsible: FIELDS_TYPES.USER,
    AuthorEmail: FIELDS_TYPES.STRING,
    ResponsibleEmail: FIELDS_TYPES.STRING,
    Author: FIELDS_TYPES.USER,
    Editor: FIELDS_TYPES.USER,
    ImportantHashTag: FIELDS_TYPES.STRING,
    Modified: FIELDS_TYPES.DATE,
    OtherFields: FIELDS_TYPES.STRING,
    OtherFieldsValues: FIELDS_TYPES.STRING,
    MImportantHashTagOld: FIELDS_TYPES.STRING,
    SDCA: FIELDS_TYPES.LOOKUP,
  },
  [myTaskActionsStatusesListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Color: FIELDS_TYPES.STRING,
    Status: FIELDS_TYPES.BOOLEAN,
  },
  [myTasksTagsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.MULTI_STRING,
  },
  [myTaskActionsHistoryListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    History: FIELDS_TYPES.STRING,
    Status: FIELDS_TYPES.LOOKUP,
    Status_x003a_Color: FIELDS_TYPES.LOOKUP,
    Action: FIELDS_TYPES.LOOKUP,
    Created: FIELDS_TYPES.DATE,
    Author: FIELDS_TYPES.USER,
  },
  [myTaskActionCommentsListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    TextComment: FIELDS_TYPES.STRING,
    Action: FIELDS_TYPES.LOOKUP,
    Created: FIELDS_TYPES.DATE,
    Author: FIELDS_TYPES.USER,
  },
  [myTaskActionCommentsFilesListName]: {
    ID: FIELDS_TYPES.ID,
    Comment: FIELDS_TYPES.LOOKUP,
    ForHistory: FIELDS_TYPES.BOOLEAN,
    FileRef: FIELDS_TYPES.STRING,
    FileLeafRef: FIELDS_TYPES.STRING,
    UniqueId: FIELDS_TYPES.STRING,
    Name: FIELDS_TYPES.STRING,
  },
};

export type MyTaskActionsListFieldsRecordType = {
  [myTaskActionsListName]: {
    MOldId: string;
    ID: number;
    Title: string;
    Description: string;
    Meeting: LookupFields;
    DateForDone: Date;
    Created: Date;
    CreateActionDate: Date;
    RejectDate: Date;
    Status: LookupFields;
    Status_x003a_Color: LookupFields;
    Responsible: UserFields;
    AuthorEmail: string;
    ResponsibleEmail: string;
    Author: UserFields;
    Editor: UserFields;
    ImportantHashTag: string;
    View: boolean;
    Modified: Date;
    OtherFields: string;
    OtherFieldsValues: string;
    MImportantHashTagOld: string;
    SDCA: LookupFields;
  };
  [myTaskActionsStatusesListName]: {
    ID: number;
    Title: string;
    Color: string;
    Status: boolean;
  };
  [myTasksTagsListName]: {
    ID: number;
    Title: string;
  };
  [myTaskActionsHistoryListName]: {
    ID: number;
    Title: string;
    History: string;
    Status: LookupFields;
    Status_x003a_Color: LookupFields;
    Action: LookupFields;
    Created: Date;
    Author: UserFields;
  };
  [myTaskActionCommentsListName]: {
    Title: string;
    ID: number;
    TextComment: string;
    Action: LookupFields;
    Created: Date;
    Author: UserFields;
  };
  [myTaskActionCommentsFilesListName]: {
    ID: number;
    Comment: LookupFields;
    ForHistory: boolean;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
  };
};

export type MyTaskActionsListFieldsType = {
  [myTaskActionsListName]: {
    MOldId: string;
    ID: number;
    Title: string;
    Description: string;
    Meeting: LookUpRecord;
    DateForDone: Moment;
    CanceledDate: Moment;
    Created: Moment;
    CreateActionDate: Moment;
    RejectDate: Moment;
    Status: LookUpRecord;
    Status_x003a_Color: LookUpRecord;
    Responsible: UserRecord;
    AuthorEmail: string;
    ResponsibleEmail: string;
    Author: UserRecord;
    Editor: UserRecord;
    ImportantHashTag: string;
    View: boolean;
    Modified: Moment;
    OtherFields: string;
    OtherFieldsValues: string;
    MImportantHashTagOld: string;
    SDCA: LookUpRecord
  };
  [myTaskActionsStatusesListName]: {
    ID: number;
    Title: string;
    Color: string;
    Status: boolean;
  };
  [myTasksTagsListName]: {
    ID: number;
    Title: string;
  };
  [myTaskActionsHistoryListName]: {
    ID: number;
    Title: string;
    History: string;
    Status: LookUpRecord;
    Status_x003a_Color: LookUpRecord;
    Action: LookUpRecord;
    Created: Moment;
    Author: UserRecord;
  };
  [myTaskActionCommentsListName]: {
    Title: string;
    ID: number;
    TextComment: string;
    Action: LookUpRecord;
    Created: Moment;
    Author: UserRecord;
  };
  [myTaskActionCommentsFilesListName]: {
    ID: number;
    Comment: LookUpRecord;
    ForHistory: boolean;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
  };
};
